import { css } from '@emotion/react';
import { DesignToken, SpacingToken } from '@livechat/design-system-react-components';
import { ellipsis } from '_assets/css/global';

import { MEDIA_MIN_SM } from '_assets/css/breakpoints';

export const container = css`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin: 0;

  ${MEDIA_MIN_SM} {
    flex-direction: row;
    justify-content: flex-start;
    margin: var(${SpacingToken.Spacing10}) 0 0 var(${SpacingToken.Spacing10});
  }
`;

export const content = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 360px;
  margin: 0;

  ${MEDIA_MIN_SM} {
    justify-content: flex-start;
    width: 600px;
    margin: 0 0 0 var(${SpacingToken.Spacing6});
  }
`;

export const largeHeading = css`
  ${ellipsis}
  color: var(${DesignToken.ContentBasicPrimary});
  max-width: 100%;
  padding: var(${SpacingToken.Spacing4}) 0 2px 0;
  text-align: center;
  margin: 0;

  ${MEDIA_MIN_SM} {
    padding: 0 0 2px 0;
    text-align: left;
  }
`;

export const smallHeading = css`
  width: 100%;
  text-align: center;
  padding: 0 var(${SpacingToken.Spacing6});
  color: var(${DesignToken.ContentBasicPrimary});
  white-space: pre-wrap;

  ${MEDIA_MIN_SM} {
    text-align: left;
    padding: 0;
    max-width: 600px;
  }
`;

export const avatarSize = css`
  height: 80px;
  width: 80px;
`;
